// src/components/MarqueeText.tsx
import React, { useEffect, useRef, useState } from 'react';
import '../styles/MarqueeText.css';

interface MarqueeTextProps {
    text: string;
    className?: string;
    speed?: number;
}

export const MarqueeText: React.FC<MarqueeTextProps> = ({
                                                            text,
                                                            className = '',
                                                            speed = 10,
                                                        }) => {
    const [needsMarquee, setNeedsMarquee] = useState(false);
    const textRef = useRef<HTMLSpanElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Сбрасываем при смене текста
        setNeedsMarquee(false);

        const checkWidth = () => {
            if (textRef.current && containerRef.current) {
                const textWidth = textRef.current.scrollWidth;
                const containerWidth = containerRef.current.clientWidth;
                setNeedsMarquee(textWidth > containerWidth);
            }
        };

        // requestAnimationFrame гарантирует что DOM уже отрендерен
        const rafId = requestAnimationFrame(() => {
            const timer = setTimeout(checkWidth, 50);
            return () => clearTimeout(timer);
        });

        window.addEventListener('resize', checkWidth);

        return () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener('resize', checkWidth);
        };
    }, [text]);

    return (
        <div ref={containerRef} className={`marquee-container ${className}`}>
            {needsMarquee ? (
                <div
                    className="marquee-content animate"
                    style={{ animationDuration: `${speed}s` }}
                >
                    <span ref={textRef}>{text}</span>
                    <span className="marquee-separator"> • </span>
                    <span>{text}</span>
                </div>
            ) : (
                // Статичный span — ref нужен для измерения
                <span ref={textRef} className="marquee-content">
                    {text}
                </span>
            )}
        </div>
    );
};